<template>
    <div class="detail-box">
        <Button @click="save" type="info">{{ $t('Button.save') }}</Button>
        <Button @click="$router.back()">{{ $t('Button.cancel') }}</Button>
        <div class="content-title">
            <Icon type="md-list" />
            <span>{{ $t('liveRoomManagement.liveRoomList.videoRef.title') }}</span>
        </div>
        <div class="content">
            <MaterialFilterBar v-model="filter" :completeOnly="true" :videoOnly="true" :userId="userId"/>
            <div></div>
            <table class="list selection">
                <thead>
                    <td width="50">{{ $t('liveRoomManagement.liveRoomList.videoRef.list.materialId') }}</td>
                    <td width="200">{{ $t('liveRoomManagement.liveRoomList.videoRef.list.name') }}</td>
                    <td>{{ $t('liveRoomManagement.liveRoomList.videoRef.list.videoDuration') }}</td>
                    <td>{{ $t('liveRoomManagement.liveRoomList.videoRef.list.preview') }}</td>
                    <td>{{ $t('liveRoomManagement.liveRoomList.videoRef.list.videoLevelCheck') }}</td>
                </thead>

                <tr v-for="(i,idx) in materials" :key="i.materialId">
                    <td>{{i.materialId}}</td>
                    <td>{{i.name}}</td>
                    <td>{{i.videoDuration}}</td>
                    <td>
                        <div class="item-thumb">
                            <PrettyImage
                                :src="i.posterPath"
                            />
                        </div>
                    </td>
                    <td>
                        <template>
                            <span v-if="p.scheduleBegin == 1" :class="{selected:p.selected}" v-for="p in i.videoLevel" :key="p.videoLevelName" @click="selectMaterial(i, p, idx)">
                                <Icon class="checkicon" type="md-checkmark-circle" size="20" />
                                <span>{{p.videoLevelName}}</span>
                            </span>
                        </template>
                    </td>
                </tr>
            </table>

            <Spin v-if="materials_loading" fix class="spin">
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <Page
                class="pager"
                :total="pagination.total"
                :current="pagination.page"
                :page-size="pagination.size"
                @on-change="v=>pagination.page=v"
                @on-page-size-change="v=>pagination.size=v"
                show-elevator
                show-sizer
            />
        </div>

        <Spin v-show="loading" fix class="spin">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import api from "@/api/Api";
import extend from "extend";
import helper from "@/assets/helper.js";
import PrettyImage from "@/components/PrettyImage";

export default {
    props: ["roomId", "userId"],
    components: {
        PrettyImage
    },
    mixins: [
        {
            methods: helper
        }
    ],
    data() {
        return {
            loading: false,
            materials_loading: false,
            materials: [],
            selectedMaterials: [],
            record: {
                name: "",
                roomId: this.roomId,
                materials: []
            },
            pagination: {
                page: 1,
                size: 10,
                total: 0
            },
            filter: {
                type: 1, //视频
                hlsTaskStatus: 4
            }
        };
    },
    computed: {
        ...mapState({
            // userId: state => state.user.id
        })
    },
    watch: {
        filter: function() {
            this.pagination.page = 1;
            this.refreshMaterial();
        },
        "pagination.page": "refreshMaterial",
        "pagination.size": "refreshMaterial"
    },
    methods: {
        cancel: function() {
            this.$router.back();
        },
        async save() {
            if(this.selectedMaterials.length == 0) {
                this.cancel();
                return;
            }

            this.loading = true;

            try {
                this.selectedMaterials.map(i=>{
                    delete i.videoLevelName;
                });
                let param = extend(true, {}, {
                    fileList: this.selectedMaterials
                }, {
                    roomId: this.roomId
                });

                let ret = await api.call("record/saveThirdVideoRecord", param, true);

                this.$Notice.success({ title: this.$t('Message.save.success') });
                this.selectedMaterials = [];
                this.$router.go(-1);
            } catch (e) {
                this.$Notice.error({ title: this.$t('Message.save.error') });
            }

            this.loading = false;
        },
        selectMaterial(i, p, idx) {
            //设置选定素材其他清晰度的选定状态selected（取消选定素材的其他清晰度选中状态）
            i.videoLevel.forEach(n => {
                if(n.videoLevelName != p.videoLevelName) n.selected = false
            });
            //点击素材清晰度选中
            p.selected = !p.selected;
            //修正数据
            if (p.selected){
                //如果该视频已被选择,先清除原来选择的清晰度
                if(this.selectedMaterials.filter(j => j.sourceId == i.materialId).length > 0){
                    this.selectedMaterials = this.selectedMaterials.filter(
                        j => j.sourceId != i.materialId
                    );
                }
                this.selectedMaterials.push({
                    sourceId: i.materialId,
                    name: i.name,
                    videoLevelName: p.videoLevelName,
                    sourceUrl: p.playUrlHlsInternet,
                    posterUrl: i.posterPath
                })
            }else {
                this.selectedMaterials = this.selectedMaterials.filter(
                    j => j.sourceId != i.materialId
                )
            }
        },
        async refreshMaterial() {
            this.materials_loading = true;
            try {
                let param = extend(true, {
                    userId: parseInt(this.userId),
                }, this.pagination, this.filter);
                let ret = await api.call("materialCms/materialList", param);
                this.materials = ret.list.map(i=>{
                    i.videoLevel.map(j => {
                        j.selected =
                            this.selectedMaterials.filter(
                                k => k.sourceId == i.materialId && k.videoLevelName == j.videoLevelName
                            ).length > 0;
                        return j
                    });
                    return i
                });
                this.pagination.total = ret.total;
            } catch (e) {;}
            this.materials_loading = false;
        }
    },
    mounted() {
        this.refreshMaterial();
    }
};
</script>
<style lang="less" scoped>
@import "../../../../assets/main-variable.less";
.detail-box {
    position: relative;
    border-radius: 5px;
    background: white;
    padding: 20px;

    button {
        margin: 10px 10px 10px 0;
        display: inline-block;
        width: 80px;
    }
    .title {
        font-size: 16px;
        display: inline-block;
        height: 40px;
        line-height: 40px;
        & > * {
            vertical-align: middle;
        }
        .title-input {
            display: inline-block;
            // width: 400px;//对于mobile 400太大，使用默认值就好
        }
    }
    .createTime {
        margin: 5px 10px;
        color: gray;
    }
    .content-title {
        font-size: 16px;
        display: block;
        height: 40px;
        margin: 30px 0 0 0;
        padding: 0;
        line-height: 40px;
        & > * {
            vertical-align: middle;
        }
    }
    .content {
        position: relative;
        .pager {
            padding: 10px 0;
        }
        .filter {
            background: #f2f2f2;
            border-radius: 5px;
        }
        .list {
            width: 100%;
            border-radius: 5px;
            border-collapse: collapse; /*表格的边框合并，如果相邻，则共用一个边框*/
            border-spacing: 0; /*设置行与单元格边框的间距。当表格边框独立（即border-collapse:separate;）此属性才起作用*/

            .item-thumb {
                height: 54px;
                /*line-height: 45px;*/
                width: 96px;
                border-radius: 5px;
                overflow: hidden;
                margin-right: 12px;
                position: relative;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    vertical-align: middle;
                    border: 0;
                }
                canvas {
                    width: 100%;
                    border: 0;
                    vertical-align: middle;
                }
            }

            tr .checkicon {
                color: #e3e3e3;
            }
            tr.selected .checkicon {
                color: @primary-color;
            }
            span .checkicon {
                color: #e3e3e3;
            }
            span.selected .checkicon {
                color: @primary-color;
            }
            td {
                padding: 12px 5px;
                border-bottom: 1px solid #e9e9e8;
                word-break: break-all
            }
        }
        .list.selection tr {
            cursor: pointer;
            
        }
        .list.selection tr:hover {
            background: #fffff2;
        }
    }
    .pager {
        text-align: center;
        padding: 10px;
    }
}
</style>

